import logo from '@/assets/logo.svg'

interface ProcessingProgressProps {
  message?: string
}

export const ProcessingProgress: React.FC<ProcessingProgressProps> = ({
  message,
}) => {
  return (
    <div className="flex flex-col items-center justify-center gap-4 p-8">
      <img src={logo} alt="AV Pulse" className="h-16 w-16 color-shift" />

      <div
        className="h-12 w-12 rounded-full border-[3px] border-border"
        style={{
          borderTopColor: 'var(--primary)',
          animation: 'spin .8s cubic-bezier(0.45, 0.05, 0.55, 0.95) infinite',
        }}
        aria-label="Processing"
        role="img"
      />

      <p className="text-sm font-bold">Analyzing creative</p>
      <p className="text-[11px] text-muted-foreground">
        {message ?? 'Running attention model…'}
      </p>

      <div className="flex gap-1">
        {[0, 1, 2].map(i => (
          <span
            key={i}
            className="h-1 w-1 rounded-full bg-primary"
            style={{ animation: `bounce 1.2s ${i * 0.2}s infinite` }}
          />
        ))}
      </div>
    </div>
  )
}
